import {
  Box,
  Card,
  CardContent,
  Chip,
  Grid,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import instagram from "assets/icons1/instagram.svg";
import facebook from "assets/icons1/facebook.svg";
import { SocialCampaignDetails } from "models/interfaces";
import {
  convertESTtoUserLocalDateAndTime,
  getSocialAppPostRedirection,
} from "helpers/methods";

interface CustomProps {
  campaignDetails: SocialCampaignDetails[];
  setCampaign: Function;
  refresh: Function;
}

const SocialDataList = (props: CustomProps) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const getSocialIcons = (type: string) => {
    switch (type) {
      case "Instagram":
        return <img src={instagram} />;
      case "Facebook":
        return <img src={facebook} />;
      default:
        return "";
    }
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case "Completed":
        return { color: "#47AA12", backgroundColor: "#F7FFF2" };
      case "Submitted":
        return { color: "#FF9436", backgroundColor: "#FFF6E2" };
      case "Draft":
        return {
          color: theme.palette.primary.dark,
          backgroundColor: "#EFEEEA",
        };
      case "Failed":
        return {
          color: "#c23118",
          backgroundColor: "#fff2f2",
        };
      case "InProgress":
        return {
          color: "#125DDB",
          backgroundColor: "#E8EFFC",
        };
      default:
        return "default";
    }
  };

  const campaignCard = (campaign: SocialCampaignDetails) => {
    return (
      <Card variant="outlined" sx={{ marginBottom: 2 }}>
        <CardContent>
          <Stack
            direction={isDesktop ? "row" : "column"}
            justifyContent="space-between"
          >
            <Box>
              <Stack direction="row" alignItems="center" spacing={1}>
                <Tooltip title={campaign.name} arrow>
                  <Typography
                    variant="h6"
                    gutterBottom
                    noWrap
                    overflow="hidden"
                    textOverflow="ellipsis"
                    whiteSpace="nowrap"
                    maxWidth="250px"
                    display="block"
                    onClick={() => {
                      if (campaign.status === "Completed") {
                        getSocialAppPostRedirection(campaign);
                      }
                    }}
                    style={{
                      cursor:
                        campaign.status === "Completed" ? "pointer" : "default",
                      textDecoration:
                        campaign.status === "Completed" ? "underline" : "none",
                    }}
                  >
                    {campaign.name}
                  </Typography>
                </Tooltip>
                <Chip
                  label={campaign.status}
                  sx={{
                    color: getStatusColor(campaign.status),
                    borderRadius: "5px",
                    minWidth: "90px",
                  }}
                  size="medium"
                />
              </Stack>
              <Typography
                variant="body2"
                color={theme.palette.primary.dark}
                gutterBottom
              >
                Created by {campaign.owner}
              </Typography>
              <Stack direction="row" spacing={1} alignItems="center">
                {getSocialIcons(campaign.socialAppName)}
                <FiberManualRecordIcon
                  fontSize="small"
                  sx={{ width: "8px", color: "#47556980" }}
                />{" "}
                <Typography
                  variant="body2"
                  sx={{ color: "#47556980" }}
                  gutterBottom
                >
                  Scheduled on{" "}
                  {convertESTtoUserLocalDateAndTime(
                    campaign.scheduleTime,
                    "MMMM D, YYYY [at] h:mm A"
                  )}
                </Typography>
              </Stack>
            </Box>
          </Stack>
        </CardContent>
      </Card>
    );
  };

  return (
    <Box mt={2}>
      <Grid container>
        {props.campaignDetails.map((campaign, index) => (
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} key={index}>
            {campaignCard(campaign)}
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default SocialDataList;
